import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Divider,
  Grid,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import GuideStyles from "assets/js/guide";

import "codemirror/lib/codemirror.css";
import "codemirror/theme/dracula.css";
import "codemirror/theme/material.css";

import "codemirror/theme/mdn-like.css";
import "codemirror/theme/the-matrix.css";
import "codemirror/theme/night.css";

import "codemirror/mode/xml/xml";
import "codemirror/mode/javascript/javascript";
import "codemirror/mode/css/css";

import "codemirror/addon/edit/closebrackets";
import "codemirror/addon/edit/closetag";
import { Controlled as ControlledEditor } from "react-codemirror2-react-17";

export default function GuideButton() {
  /* Accordion */
  const [codemirror, setCodemirror] = useState();
  const handleCodemirror = panel => (event, newcodemirror) => {
    setCodemirror(newcodemirror ? panel : false);
  };

  return (
    <>
      <GuideStyles />
      <main id="main" className="container">
        <Box className="box-type-2">
          <div className="h-group">
            <h2 className="guide-h2">Typography</h2>
          </div>

          <h3 className="guide-h3">Default</h3>
          <p>FontSize : 16px</p>
          <p>Color : #000</p>
          <p>LineHeight : 1.5</p>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Typeface</h3>
          <div className="guide-cont">
            <p>- NanumSquareRound</p>
            <Grid container spacing={1} className="guide-typeface">
              <Grid item>
                <div className="item">
                  <p className="font weight300">Aa</p>
                  <div className="info">
                    <span className="label">Light</span>
                    <span className="value">300</span>
                  </div>
                </div>
              </Grid>
              <Grid item>
                <div className="item">
                  <p className="font">Aa</p>
                  <div className="info">
                    <span className="label">Regular</span>
                    <span className="value">400</span>
                  </div>
                </div>
              </Grid>
              <Grid item>
                <div className="item">
                  <p className="font weight700">Aa</p>
                  <div className="info">
                    <span className="label">Bold</span>
                    <span className="value">700</span>
                  </div>
                </div>
              </Grid>
              <Grid item>
                <div className="item">
                  <p className="font weight800">Aa</p>
                  <div className="info">
                    <span className="label">Black</span>
                    <span className="value">800</span>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Ellipsis</h3>
          <p className="ellipsis">
            시각장애인용 테스트 전단 활용방법에 대한 논의 시각장애인용 테스트
            전단 활용방법에 대한 논의
          </p>
          <div className="title-group">
            <p className="title ellipsis">
              시각장애인용 테스트 전단 활용방법에 대한 논의 시각장애인용 테스트
              전단 활용방법에 대한 논의
            </p>
            <i className="ico-new" />
          </div>

          <Accordion
            codemirror={codemirror === "Ellipsis"}
            onChange={handleCodemirror("Ellipsis")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`<p className="ellipsis">
  시각장애인용 테스트 전단 활용방법에 대한 논의 시각장애인용 테스트
  전단 활용방법에 대한 논의
</p>

<div className="title-group">
  <p className="title ellipsis">
    시각장애인용 테스트 전단 활용방법에 대한 논의 시각장애인용 테스트
    전단 활용방법에 대한 논의
  </p>
  <i className="ico-new" />
</div>
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Info Text</h3>
          <p className="info-txt">FontSize 14px / color #8E8E8E</p>
          <p className="info-txt">5만원 이상 결제 시</p>

          <Accordion
            codemirror={codemirror === "InfoText"}
            onChange={handleCodemirror("InfoText")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`<p className="info-txt">5만원 이상 결제 시</p>
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>
        </Box>
      </main>
    </>
  );
}
